import config from 'config'
import { doIntegrationsWriteRequest } from 'ducks/requests'
import { shopifyGidToId } from 'ducks/integrations/shopify/utils'
import doCreateShopifyEvent from './doCreateShopifyEvent'
import doFetchOrderById from './doFetchOrderById'
import { ORDER_CANCEL_REQUEST } from '../types'

const doCancelOrder = (
  integrationId,
  orderId,
  conversationId,
  data
) => async dispatch => {
  const orderShortId = shopifyGidToId(orderId)

  const url = `proxy/shopify/admin/api/${
    config.shopify.restApiVersion
  }/orders/${orderShortId}/cancel.json?gid=${integrationId}`

  const result = await dispatch(
    doIntegrationsWriteRequest(ORDER_CANCEL_REQUEST, url, data, {
      moduleOptions: {
        toasts: {
          enabled: true,
          started: {
            enabled: false,
          },
          success: {
            enabled: true,
            content: 'Order cancelled',
          },
          failed: {
            enabled: true,
            content: 'Order cancellation failed',
          },
        },
      },
    })
  )

  if (orderId && conversationId) {
    dispatch(
      doCreateShopifyEvent(
        integrationId,
        orderId,
        conversationId,
        'ORDER_CANCELED'
      )
    )
  }

  dispatch(doFetchOrderById(integrationId, orderId))

  return result
}

export default doCancelOrder
